import { AppState, Auth0Provider } from "@auth0/auth0-react";
import { FC, ReactNode } from "react";
import { useNavigate } from "react-router-dom";

interface Auth0ProviderWithNavigateProps {
  children: ReactNode;
}

const domain = process.env.REACT_APP_AUTH0_DOMAIN;
const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
const redirectUri = window.location.origin;
const audience = process.env.REACT_APP_AUTH0_AUDIENCE;

const Auth0ProviderWithNavigate: FC<Auth0ProviderWithNavigateProps> = ({
  children,
}) => {
  const navigate = useNavigate();

  const onRedirectCallback = (appState?: AppState) => {
    sessionStorage.setItem("authFlag", 'true');
    navigate(appState?.returnTo || window.location.pathname);
  };

  if (!(domain && clientId && redirectUri)) {
    return null;
  }

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        scope: "openid profile email",
        redirect_uri: redirectUri,
        audience: audience

      }}
      onRedirectCallback={onRedirectCallback}
      useRefreshTokens={false}
      cacheLocation="localstorage"
      useCookiesForTransactions={false}
      
    >
      {children}
    </Auth0Provider>
  );
};

export default Auth0ProviderWithNavigate;
